<script>
import { h, resolveComponent, inject, resolveDirective, withDirectives } from 'vue';
export default {
  name: 'lego-tree-policy-node',
  props: {
    node: { type: Object, required: true },
    position: { type: Array, required: true },
    draggable: { type: Boolean, default: true }
  },
  inject: [
    't',
    'checkbox',
    'labelInfo',
    'labelAction',
    'rules', // props or data
    'reRender',
    'onClickNode',
    'onClickExpand',
    'onClickCheckbox',
    'emitClickDeleteButton',
    'emitClickEditButton',
    'emitClickAddButton',
    'dragstart',
    'dragleave',
    'dragenter',
    'dragend',
    'onlyRemove',
    'addPolicyObjectText',
    'viewMode',
    'noSelectNode'
  ], // methods
  render(props) {
    let t = props.t;
    let node = props.node;
    let treeInfo = props.node.treeInfo;
    let childNodes = props.node.children;
    let policyItem = props.node.treeInfo.policy;
    let dragFlag = props.draggable;
    let onClickNode = (e) => props.onClickNode(e, node, props.position);
    let onClickExpand = (e) => props.onClickExpand(e, node);
    let onClickCheckbox = (e) => props.onClickCheckbox(e, node, props.position);
    let emitClickDeleteButton = (e) => props.emitClickDeleteButton(e, node, props.position);
    let emitClickEditButton = (e) => props.emitClickEditButton(e, node, props.position);
    let emitClickAddButton = (e) => props.emitClickAddButton(e, node, props.position);
    let dragstart = (e) => props.dragstart(e, props.position);
    let dragleaveOnLabel = (e) => {
      clearTimeout(e.target._expandOnTimeout);
      return props.dragleave(e);
    };
    let dragenterOnLabel = (e) => {
      e.target._expandOnTimeout = setTimeout(() => onClickExpand(e), 1000);
      props.dragenter(e, node);
    };
    let dragleave = (e) => props.dragleave(e);
    let dragenter = (e) => props.dragenter(e);
    let dragendOnHeader = (e) => props.dragend(e, props.position, 'BEFORE');
    let dragendOnLabel = (e) => props.dragend(e, props.position, 'CHILD');
    let dragendOnFooter = (e) => props.dragend(e, props.position, 'AFTER');
    const legoIcon = resolveComponent('lego-icon');
    const legoIconWrapper = resolveComponent('lego-icon-wrapper');
    const legoChip = resolveComponent('lego-chip');
    const legoTreePolicyNode = resolveComponent('lego-tree-policy-node');
    const legoButton = resolveComponent('lego-button');
    const legoTooltip = resolveDirective('lego-tooltip');
    let toggleIcon = '';
    if (treeInfo.hasChild) {
      toggleIcon = h(legoIcon, {
        iconType: 'df',
        icon: treeInfo.expanded ? 'tree_minus' : 'tree_plus',
        iconSize: 16,
        onClick: onClickExpand
      });
    } else {
      toggleIcon = h(
        'span',
        {
          class: { 'no-child-icon': true }
        },
        []
      );
    }

    let toggleButton = h(
      'div',
      {
        class: 'lego-tree-node__contents__toggle-button'
      },
      [toggleIcon]
    );

    let checkbox = '';
    let $_checkIcon = treeInfo.checked;
    if (typeof $_checkIcon !== 'string') {
      $_checkIcon = $_checkIcon ? 'checked' : 'box';
    }
    if (props.checkbox) {
      checkbox = h(
        'div',
        {
          class: {
            'lego-tree-node__contents__checkbox': true,
            'lego-tree-node__contents__checkbox--checked': treeInfo.checked
          }
        },
        [
          h(legoIcon, {
            props: {
              icon: $_checkIcon,
              iconSize: 16,
              iconType: 'picto'
            },
            onClick: onClickCheckbox
          })
        ]
      );
    }

    let label;
    label = props.$slots.treeNodeLabel && props.$slots.treeNodeLabel({ node: props.node });
    if (!label) {
      if (typeof props.labelInfo === 'function') {
        label = props.labelInfo(props.node);
      } else if (typeof props.labelInfo === 'object' && props.labelInfo.field) {
        label = [];
        for (let field of props.labelInfo.field) {
          let curr = props.node;
          for (let keyword of field.split('.')) {
            curr = curr[keyword];
          }
          label.push(curr);
        }
        label = label.join(props.labelInfo.separator || '');
      } else {
        label = '';
      }
    }

    let labelActionGroup = '';
    if (props.labelAction) {
      labelActionGroup = h(
        'div',
        {
          class: 'lego-tree-node__contents__action-group'
        },
        [
          !props.onlyRemove &&
            h(
              legoIconWrapper,
              {
                class: 'lego-tree-node__contents__action-icon'
              },
              () => [
                h(legoIcon, {
                  icon: 'modify',
                  iconSize: '14px',
                  onClick: emitClickEditButton
                })
              ]
            ),
          !props.viewMode &&
            h(
              legoIconWrapper,
              {
                class: 'lego-tree-node__contents__action-icon'
              },
              () => [
                h(legoIcon, {
                  iconType: 'df',
                  icon: 'delete_box_solid_24',
                  iconSize: 16,
                  onClick: emitClickDeleteButton
                })
              ]
            )
        ]
      );
    }

    let chips = h('div', { class: 'policy-status-chips' }, [
      policyItem &&
        policyItem.map((item) => {
          return h(
            legoChip,
            {
              small: true,
              statusColor: item.status
            },
            [item.name]
          );
        })
    ]);
    // const legoTooltipDirective = resolveDirective({
    //   name: 'lego-tooltip',
    //   value: label,
    //   arg: 'ellipsis'
    // });

    let contentsLabel = withDirectives(
      h(
        'div',
        {
          class: {
            'lego-tree-node__contents__label': true,
            'no-select': props.noSelectNode
          },
          draggable: dragFlag,
          onClick: onClickNode,
          onDragstart: dragstart,
          onDragenter: dragenterOnLabel,
          onDragleave: dragleaveOnLabel,
          onDragover: (e) => e.preventDefault(),
          onDrop: dragendOnLabel
        },
        [label]
      ),
      [[legoTooltip, label, 'ellipsis']]
    );

    let content = h(
      'div',
      {
        class: {
          'lego-tree-node__contents': true,
          'lego-tree-node__contents--searched': treeInfo.searched,
          'lego-tree-node__contents--selected': treeInfo.selected,
          'lego-tree-node__contents--root': treeInfo.depth === 0
        }
      },
      [toggleButton, checkbox, contentsLabel, policyItem && chips, labelActionGroup]
    );

    let childrenWrapper = '';
    if (treeInfo.hasChild && treeInfo.expanded) {
      let childTreeNodes = [];
      let idx = 0;
      if (childNodes && childNodes.length > 0) {
        childNodes.forEach((child, index) => {
          let childPosition = props.position.slice(0);
          childPosition.push(idx);
          childTreeNodes.push(
            h(legoTreePolicyNode, {
              node: child,
              position: childPosition,
              draggable: dragFlag,
              slots: props.$slots
            })
          );

          if (childNodes.length === index + 1 && !props.viewMode) {
            childTreeNodes.push(
              h(
                'div',
                {
                  class: 'add-btn'
                },
                [
                  h(
                    legoButton,
                    {
                      sm: true,
                      class: 'tree-node-add-btn',
                      onClick: emitClickAddButton
                    },
                    () => [
                      h(legoIcon, {
                        iconType: 'df',
                        icon: 'add_border',
                        iconSize: 16
                      }),
                      props.addPolicyObjectText || t('button.addPolicyObject')
                    ]
                  )
                ]
              )
            );
          }
          idx += 1;
        });
      } else {
        childTreeNodes.push(
          h('div', {}, [
            'loading...' // FIXME: 임시로 넣어놓음. 추후 수정필요
          ])
        );
      }
      childrenWrapper = h(
        'div',
        {
          class: 'lego-tree-node__vertical-line'
        },
        childTreeNodes
      );
    }

    let contentHeader = '';
    if (props.position[props.position.length - 1] === 0) {
      contentHeader = h('div', {
        class: 'lego-tree-node__header',
        onDragenter: dragenter,
        onDragleave: dragleave,
        onDragover: (e) => e.preventDefault(),
        onDrop: dragendOnHeader
      });
    }

    let contentFooter = h('div', {
      class: 'lego-tree-node__footer',
      onDragenter: dragenter,
      onDragleave: dragleave,
      onDragover: (e) => e.preventDefault(),
      onDrop: dragendOnFooter
    });

    return h(
      'div',
      {
        class: 'lego-tree-node'
      },
      [contentHeader, content, childrenWrapper, contentFooter]
    );
  }
};
</script>
<style lang="scss" scoped>
.lego-tree-node {
  &__contents {
    align-items: center;

    &--selected {
      font-weight: 500;
    }
  }
  .lego-tree-node__contents__label {
    height: 36px;
    padding-right: 0 !important;
    flex: 0 1 auto;

    &:hover {
      background: none;
      color: $color--primary;
    }

    &.no-select {
      pointer-events: none;
    }
  }
  .lego-tree-node__contents__action-group {
    margin-left: 10px;
    display: inline;
    position: inherit !important;
    .lego-icon {
      color: rgba($color--ui01, 0.6);
    }
  }
  .lego-tree-node__contents__toggle-button {
    color: $color--ui04;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    .lego-icon {
      &:hover {
        background-color: transparent;
        color: $color--primary;
      }
    }

    .no-child-icon {
      display: inline-block;
      margin: 6px;
      width: 3px;
      height: 3px;
      border-radius: 50%;
      background: $color--ui04;
      cursor: default;
    }
  }

  & + .lego-tree-node {
    margin-top: 0;
  }

  .policy-status-chips {
    display: flex;
    align-items: center;
    padding-left: 8px;
    margin-right: -2px;
    color: $color--ui01;
    font-weight: 400;
    .lego-chip__container + .lego-chip__container {
      margin-left: 4px;
    }
  }
}
</style>
